import styled from 'styled-components'

export const Icon = styled.img``

export const ColumnFlexDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent || 'center'};
  align-items: ${(props) => props.alignItems || 'flex-start'};
  background-color: ${(props) => props.backgroundColor};
  text-overflow: ellipsis;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  padding: ${(props) => props.padding};
`

export const RowFlexDiv = styled.div`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  opacity: ${({ opacity }) => opacity};
  z-index: ${({ zIndex }) => zIndex};
  overflow: ${({ overflow }) => overflow};
  text-overflow: ellipsis;
  transition: width 0.1s, opacity 0s;
  /* transition: width 15s opacity 15s; */

  white-space: nowrap;
  outline: ${(props) => props.outline};
  background-color: ${(props) => props.backgroundColor};
  border-radius: ${(props) => props.borderRadius};
  position: ${(props) => props.position};
  cursor: ${(props) => props.Cursor};

  display: flex;
  flex-direction: row;
  justify-content: ${(props) => props.justifyContent || 'space-between'};
  align-items: ${(props) => props.alignItems || 'center'};
  align-self: ${(props) => props.alignSelf};
  gap: ${({ gap }) => gap};
  margin: ${({ margin }) => margin};
  margin-left: ${(props) => props.marginLeft};
  margin-top: ${(props) => props.marginTop};
`

export const SearchInput = styled.input`
  background-image: url(${({ icon }) => icon});
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: 14px 0.6rem;
  padding-left: 40px;
  opacity: 0.77;
  border-radius: 4px;
  width: ${({ width }) => width};
  height: 31px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: none;
  background-color: rgba(255, 255, 255, 0.34);
  ::placeholder {
    font-family: nudista-web, sans-serif;
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #250f43;
  }
  font-family: nudista-web, sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #250f43;
`

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 30px;
  width: 100%;
  height: 100%;

  padding: 8px 0 18px 0;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  position: fixed;
  overflow: hidden;
  margin: 0 0 0 99px;
  width: ${({ width }) => width};
  transition: width 0.5s;
  height: 100vh;
  z-index: 100;
  box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.32);
  -webkit-box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.32);
  -moz-box-shadow: 3px 0px 5px 0px rgba(0, 0, 0, 0.32);
  background-color: ${(props) => props.backgroundColor || '#dfdbe3'};
`
